export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '什么是十八禁内容？',
    answer: '十八禁内容是指仅适合十八岁以上成年人观看或访问的内容类型。根据不同国家和地区的法律及行业标准，这类内容通常包含成人主题、暴力场景或其他需要年龄限制的敏感内容。在中国法律框架下，十八禁内容的传播受到严格监管，必须符合相关法律法规的要求。',
  },
  {
    question: '如何确保未成年人无法访问十八禁内容？',
    answer: '保护未成年人免受不适宜内容的影响是一项系统性工程。有效的未成年人保护机制包括：实施强身份年龄验证（如身份证实名认证、人脸识别等）、建立完善的内容分级过滤系统、提供家长控制工具、开展网络安全教育。平台运营者应建立AI+人工的双重审核体系，并依法依规对违规内容采取处置措施。',
  },
  {
    question: '十八禁内容在中国是否合法？',
    answer: '中国法律对淫秽内容与成人内容有着明确的界定标准。传播淫秽物品属于违法犯罪行为，受到刑法和治安管理处罚法的严格规制。对于艺术、教育、医学等正当用途中涉及成人主题的内容，在符合相关法律法规和行业标准的前提下可以进行有限度的传播。建议内容创作者和平台运营者密切关注相关法律动态，确保合规运营。',
  },
  {
    question: '各国对十八禁内容的监管有什么不同？',
    answer: '不同国家在成人内容监管方面存在显著差异。美国采用宪法第一修正案框架下的分级制度，欧洲强调用户权利和数据保护，英国对在线安全提出了严格的年龄验证要求，日本则有完善的内容分级自律体系，东南亚国家多采取较为严格的管控政策。了解各国监管差异对于跨国运营的内容平台尤为重要。',
  },
  {
    question: '年龄验证技术有哪些主流方案？',
    answer: '当前主流的年龄验证技术方案包括：身份证件验证（与权威数据库比对）、人脸识别年龄估计、第三方信用验证、银行卡验证、手机号实名校验等。不同方案在准确性、用户体验、隐私保护和实施成本方面各有优劣。推荐采用分层验证策略：根据内容风险等级匹配相应强度的验证方式。',
  },
  {
    question: '平台运营者需要注意哪些合规事项？',
    answer: '成人内容平台运营者应重点关注：建立健全内容审核机制（AI+人工双重审核）、实施有效的年龄验证系统、制定清晰的内容分级标准、建立用户举报和投诉处理渠道、保护用户隐私和个人信息安全、定期开展合规培训和审计、保持与监管机构的良好沟通。同时应关注相关法律法规的更新动态，及时调整合规策略。',
  },
];